import ModeloService from "../../services/ModeloService";
import SelectModelo from "./SelectModelo";

export default class SelectModeloByMarcaAndAno extends SelectModelo {

    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);
    }

    componentDidUpdate(nextProps) {
        super.componentDidUpdate(nextProps);
        if (nextProps.idMarca !== this.props.idMarca || nextProps.nrAno !== this.props.nrAno) {            
            this.getOptions();
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getOptions(callBack) {
        if (this.props.idMarca && this.props.nrAno && this.props.nrAno.toString().length >= 4) {
            ModeloService.getForComboByMarcaAndAno(this.props.idMarca, this.props.nrAno, (response) => {
                this.setState({ options: response }, () => {
                    if (callBack) {
                        callBack();
                    }
                });
            });
        } else {
            this.setState({ options: [] }, () => {
                if (callBack) {
                    callBack();
                }
            });
        }
    }

    render() {
        return super.render();
    }
}